import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { differenceInDays } from 'date-fns';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent, SimpleConfigBaseFilter } from 'gung-list';
import { MetadataService, Order } from 'gung-standard';
import { JeevesOpenOrdersListTableConfigService, OrderDateStringFilter } from 'gung-standard-jeeves';
import { first, forkJoin, map, mergeMap, of } from 'rxjs';
import { ColmecOpenOrderTableComponent } from '../../components/colmec-open-order-table/colmec-open-order-table.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecOpenOrdersConfigService extends JeevesOpenOrdersListTableConfigService {
  getLayouts(): ListLayout<Order>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => ColmecOpenOrderTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Order list'
      }
    ];
  }

  getItems() {
    // Remove annulled orders (ordstat = 90)
    return this.orderService.getOpenOrders().pipe(
      mergeMap(items =>
        forkJoin([
          of(items.filter(order => order.extra.oh.ordstat !== 90)),
          this.customerService.getCustomers().pipe(first())
        ])
      ),
      map(([orders, customers]) => {
        const result = orders.map(order => {
          return {
            ...order,
            extra: {
              ...order.extra
            }
          };
        });

        result.map(resOrder => {
          const cust = customers.find(customer => customer.id === resOrder.deliveryCustomerId);
          resOrder.extra.customerName = cust ? cust.name : '';
          return resOrder;
        });

        const sorted = result.sort((a, b) => {
          if (a.extra.oh.orddatum > b.extra.oh.orddatum) {
            return 1;
          }
          if (a.extra.oh.orddatum < b.extra.oh.orddatum) {
            return -1;
          }
          return 0;
        });

        return sorted.reverse();
      })
    );
  }

  getFilters(): ConfigBaseFilter<Order>[] {
    return [
      new OrderDateStringFilter(this.translationService),
      new OrderExpectedDeliveryFilter(this.translationService),
      new OrderStatusFilter(this.translationService, this.metadataService)
    ];
  }
}

class OrderStatusFilter extends SimpleConfigBaseFilter<Order> {
  constructor(protected translateService: TranslateService, protected metadataService: MetadataService) {
    super();
  }

  getName(): string {
    return 'ORDER_STATUS';
  }
  getOptionIds(item: Order): string[] {
    if (item.extra.oh.ordstat === 0) {
      return ['QUOTE'];
    }
    if (item.extra.oh.ordstat === 13) {
      return ['REGISTERED'];
    }

    if (item.extra.oh.ordstat === 10) {
      return ['ORDER_STATUS_WARNING_ENTRY_IN_PROGRESS'];
    }

    if (item.extra.oh.ordstat === 5) {
      return ['WEBORDER'];
    }

    if (item.extra.oh.ordstat === 11) {
      return ['QUOTE'];
    }

    return ['UNDEFINED'];
  }
  getOptionName(key: string): string {
    const value = this.metadataService.getMetadataValue('x7', 'ordstatbeskr', key);
    return this.translateService.instant(key);
  }
}

class OrderExpectedDeliveryFilter extends SimpleConfigBaseFilter<Order> {
  constructor(protected translateService: TranslateService) {
    super();
  }

  getName(): string {
    return 'EXPECTED_DELIVERY_DATE';
  }

  getOptionIds(item: Order): string[] {
    const dayDifferense = differenceInDays(new Date(), new Date(item.extra.oh.ordberlevdat));

    if (dayDifferense <= 1) {
      return ['TODAY'];
    }
    if (dayDifferense <= 7) {
      return ['THIS_WEEK'];
    }
    if (dayDifferense <= 30) {
      return ['THIS_MONTH'];
    }
    if (dayDifferense <= 90) {
      return ['LAST_THREE_MONTHS'];
    }
    return ['OVER_THREE_MONTHS'];
  }

  getOptionName(key: string): string {
    return this.translateService.instant(key);
  }
}
